<div class="p-fluid p-dir-col p-p-3">
  <div class="form-group has-float-label mb-2">
    <div>
      <div class="form-group has-float-label">
        <label class="form-label">Client Account</label>
        <input
          pInputText
          #mydropClient
          jniAutoCompleteBlocker
          type="text"
          id="customerAccount"
          name="customerAccount"
          class="form-control"
          [value]="customerIdD365"
          (input)="customerSearch$.next($any($event.target).value)"
          (keyup)="
            onCustomerSearchOpenToggle(clientPopover, $event, mydropClient)
          "
          (keydown.Tab)="getCustomerAccount($event, clientPopover)"
          (click)="onClienySearchList(clientPopover, $event, mydropClient)"
          (change)="changeClientAccount($event)" />
      </div>
      <p-popover
        class="order-dropdown add dropDownPosition search-table-position"
        #clientPopover>
        <p-table
          #dt
          [value]="customerLists"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Name</th>
              <th class="vaccount">Client Account</th>
              <th class="street" style="width: 100px" pSortableColumn="street">
                Street
                <p-sortIcon field="street"></p-sortIcon>
              </th>
              <th class="city" pSortableColumn="city">
                City
                <p-sortIcon field="city"></p-sortIcon>
              </th>
              <th class="state" pSortableColumn="state">
                State
                <p-sortIcon field="state"></p-sortIcon>
              </th>
              <th class="state" pSortableColumn="billingAttentionD365">
                Attention
                <p-sortIcon field="billingAttentionD365"></p-sortIcon>
              </th>
              <th class="country">Last order date</th>
            </tr>

            <tr>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="street"
                    id="street"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'street', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="city"
                    id="city"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'city', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="state"
                    id="state"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'state', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="billingAttentionD365"
                    id="billingAttentionD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'billingAttentionD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>

              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-customerList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="onClientSelection(customerList, clientPopover)">
              <td class="name mousepointer">
                {{ customerList.organizationNameD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ customerList.clientAccount }}
              </td>
              <td style="width: 200px" class="sname mousepointer">
                {{ customerList.street }}
              </td>
              <td class="city mousepointer">{{ customerList.city }}</td>
              <td style="width: 72px" class="state mousepointer">
                {{ customerList.state }}
              </td>
              <td style="width: 72px" class="state mousepointer">
                {{ customerList.billingAttentionD365 }}
              </td>
              <td style="width: 75px" class="country mousepointer">
                {{ customerList.lastOrderDate | date: "yyyy-MM-dd" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No client found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>
  </div>
  <div class="form-group has-float-label mb-2 mt-2">
    <label class="form-label">Job Name</label>
    <input
      pInputText
      jniAutoCompleteBlocker
      type="text"
      class="form-control"
      [(ngModel)]="jobName" />
  </div>

  <div class="form-group has-float-label mb-2 mt-2">
    <div>
      <div class="form-group has-float-label">
        <label class="form-label">Buyer</label>
        <div
          style="text-align: right; margin-top: -15px"
          *ngIf="customerIdD365 !== ''">
          <a class="small-link no-decoration" (click)="addContactInformation()"
            >+Add</a
          >
        </div>
        <input
          pInputText
          #mydropBuyer
          jniAutoCompleteBlocker
          type="text"
          id="buyer"
          name="buyer"
          class="form-control"
          [value]="buyerName"
          (input)="buyerVendor$.next($any($event.target).value)"
          (keyup)="onBuyerSearchOpenToggle(buyerPopover, $event, mydropBuyer)"
          (keydown.Tab)="getBuyer($event, buyerPopover)"
          (click)="onContactList(buyerPopover, mydropBuyer, $event)" />
      </div>
      <p-popover
        class="order-dropdown add dropDownPosition search-table-position"
        #buyerPopover>
        <p-table
          #dtBuyer
          [value]="buyerLists"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Buyer</th>
              <th class="client" pSortableColumn="client">
                Client
                <p-sortIcon field="Client"></p-sortIcon>
              </th>
              <th class="vaccount">Account</th>
              <th class="street">Street</th>
              <th class="city">City</th>
              <th class="state">State</th>
              <th class="lastOrderDate">Last order date</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="buyer"
                    id="buyer"
                    style="max-width: 200px"
                    (input)="
                      dtBuyer.filter(
                        $any($event.target).value,
                        'buyer',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="organizationNameD365"
                    id="organizationNameD365"
                    style="max-width: 200px"
                    (input)="
                      dtBuyer.filter(
                        $any($event.target).value,
                        'organizationNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-buyerList let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="onBuyerSelection(buyerList, buyerPopover)">
              <td class="buyer mousepointer">
                {{ buyerList.buyer }}
              </td>
              <td class="client mousepointer">
                {{ buyerList.organizationNameD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ buyerList.account }}
              </td>
              <td style="width: 200px" class="sname mousepointer">
                {{ buyerList.street }}
              </td>
              <td class="city mousepointer">{{ buyerList.city }}</td>
              <td style="width: 72px" class="state mousepointer">
                {{ buyerList.state }}
              </td>
              <td style="width: 75px" class="country mousepointer">
                {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No buyer found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>
  </div>
  <div
    class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
    <!-- <button
      class="btn btn-primary"
      type="click"
      (click)="addNewProjectHeader()">
      Create New
    </button> -->
    <p-button label=" Create New" (click)="addNewProjectHeader()" />
  </div>
</div>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [addClientContact]="addClientContact"
  [isFromOrdersAddNewBuyer]="true"
  [customerAccountNumber]="customerIdD365"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
